import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { FeaturedTourCategories } from '../container/FeaturedTourCategories';
import SearchTour from '../container/SearchTour';

export default function HomePage() {
  const { t } = useTranslation();

  return (
    <Box maxWidth="1400px" margin="auto" sx={{ mt: 2 }}>
      <SearchTour />

      <Typography variant="h5" sx={{ my: 2, textAlign: 'center' }}>
        {t('homePage.featuredTours')}
      </Typography>

      <FeaturedTourCategories />
    </Box>
  );
}
